import { sleep } from '../../lib/utils';
import { default as service } from '.';
import { logErrorToServerside } from '../serverSideLogging';

const polloveride = localStorage.getItem('poll-duration');

const POLL_DURATION = polloveride ? parseInt(polloveride, 10) : 30_000;

type StatusType = Awaited<ReturnType<typeof service.status>>;
export default async function pollForApplicationState(
    applicationId: string,
    applicantId: null | string,
    condition: (applicationStatus: StatusType) => boolean
) {
    const duration = POLL_DURATION;
    const startTime = Date.now();
    let controller: AbortController | null = null;
    let now = startTime;
    let res: StatusType = null;
    do {
        controller && controller.abort();
        controller = new AbortController();
        try {
            res = await service.status(applicationId, applicantId, controller.signal);
            if (res && condition(res)) {
                return res;
            }
        } catch (ex) {
            logErrorToServerside(`Error getting status`, applicationId, null, ex, 'O2');
        }
        await sleep(2000);
        now = Date.now();
    } while (now - startTime < duration);

    return undefined;
}
